<template>
  <v-dialog
    v-model="show"
    :max-width="options.maxWidth"
    :transition="transition"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
  >

    <v-card
      style="height:500px;"
      column
    >

      <v-toolbar
        dark
        color="primary"
        column
        flat
        style="border-bottom: 1px solid #f5f5f5; background-color:white; margin:0px; padding:0px;"
      >

        <v-toolbar-title>Advanced Patient Search</v-toolbar-title>

      </v-toolbar>

      <v-toolbar
        style="cursor:pointer;"
        @click="queryMode()"
        class="fade-in slow"
        v-show="this.searchBanner"
      >
        <v-icon class="mr-2">search</v-icon><span>{{searchQuery}}</span>
        <v-spacer></v-spacer>
        <v-btn
          @click="queryMode()"
          icon
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-slide-y-transition>
          <v-layout
            v-show="!this.searchBanner"
            column
          >
            <span style="font-size:18px; font-weight:700;">Patient Information</span>
            <v-layout
              row
              wrap
              class="mt-3"
              align-center
            >
              <v-text-field
                required
                v-model="patientLastName"
                label="Last Name"
                outline
                hint="Case-Sensitive, Exact"
                persistent-hint
              >
              </v-text-field>
              <v-text-field
                required
                class="ml-2"
                label="First Name"
                v-model="patientFirstName"
                outline
              >
              </v-text-field>

              <v-text-field
                required
                class="ml-2"
                outline
                v-model="dateFormatted"
                label="Date of Birth"
                hint="MM/DD/YYYY format"
                persistent-hint
                mask="##/##/####"
                @blur="date = parseDate(dateFormatted)"
              ></v-text-field>

            </v-layout>

            <v-layout
              style="opacity:0.5;"
              column
            >
              <span
                style="font-size:18px; font-weight:700;"
                class="mb-2"
              >Privacy Notice</span>
              <span>Medical record privacy is protected by Federal Law.
                The medical information contained within OneChart is privileged and confidential, and may only be accessed for the purposes of continuing care.
                Improper use or unauthorized access to medical information may be subject to State and Federal penalties.
                Any disclosure, copying, use, or distribution of the information contained in OneChart without the explicit permission of the patient is strictly prohibited.</span>

            </v-layout>

          </v-layout>

        </v-slide-y-transition>

        <v-data-table
          v-show="this.searchBanner && patientSearchResultsCleaned.length > 0"
          :headers="headers"
          :items="patientSearchResultsCleaned"
          sort-icon=""
          class="flat mb-2 table-border"
          :rows-per-page-items="[1000]"
          color="#eeeeee"
          :loading="isLoading"
        >
          <v-progress-linear
            slot="progress"
            color="blue"
            indeterminate
          ></v-progress-linear>
          <template slot="no-data">
            <v-layout
              column
              justify-center
              align-center
              style="min-height:350px; opacity:0.3;"
            >

              <v-icon
                style="border-radius:50%; height:80px; width:80px; border: 3px solid #999999;"
                x-large
              >folder_open</v-icon>
              <div style="width:250px; margin-top:5px; opacity:0.6; text-align: center;">
                <p style="font-weight:700">OneChart Health</p>
              </div>

            </v-layout>
          </template>
          <template
            slot="items"
            slot-scope="props"
          >
            <tr
              style="cursor:pointer"
              @click="props.expanded = !props.expanded"
            >
              <td class="text-xs-left">{{ props.item.fullName }}</td>
              <td
                v-if="!isMobile"
                class="text-xs-left"
              >{{ props.item.gender }}</td>
              <td class="text-xs-right">{{ props.item.birthdateString }}</td>
            </tr>
          </template>
          <template
            slot="expand"
            slot-scope="props"
          >
            <v-card
              class="mb-3"
              flat
            >
              <v-card-title style="font-size:18px; font-weight:700;">
                {{ props.item.fullName }}
              </v-card-title>
              <v-card-text>
                <v-layout column>
                  <v-layout
                    row
                    wrap
                  >
                    <v-card
                      flat
                      class="ma-1 mr-2"
                    >
                      <v-layout column>
                        <span>Birthdate</span>
                        <span>{{props.item.birthdateString}}</span>
                      </v-layout>
                    </v-card>
                    <v-card
                      flat
                      class="ma-1 mr-2"
                    >
                      <v-layout column>
                        <span>Gender</span>
                        <span>{{props.item.gender}}</span>
                      </v-layout>
                    </v-card>
                    <v-card
                      flat
                      class="ma-1 mr-2"
                    >
                      <v-layout column>
                        <span>Address</span>
                        <span>{{providerDisplayAddressFromProviderObject(props.item)}}</span>
                      </v-layout>
                    </v-card>

                    <v-card
                      flat
                      class="ma-1"
                    >
                      <v-layout column>
                        <span>Phone</span>
                        <span>{{props.item.phone}}</span>
                      </v-layout>
                    </v-card>

                  </v-layout>
                </v-layout>
              </v-card-text>
              <v-toolbar
                flat
                color="transparent"
              >

                <v-spacer></v-spacer>

                <v-btn
                  left
                  depressed
                  @click="selectPatient(props.item)"
                  color="primary"
                >Select Patient</v-btn>
              </v-toolbar>
            </v-card>
          </template>
        </v-data-table>

        <v-layout
          v-show="showEmptyResults"
          column
          justify-center
          align-center
          style="min-height:350px; opacity:0.3;"
        >

          <v-icon
            style="border-radius:50%; height:80px; width:80px; border: 3px solid #999999;"
            x-large
          >warning</v-icon>
          <div style="width:250px; margin-top:5px; opacity:0.6; text-align: center;">
            <p style="font-weight:700">No Matching Results</p>
          </div>

        </v-layout>

      </v-card-text>

      <!-- Actions -->
      <v-spacer></v-spacer>

      <v-card-actions class="px-3 pb-3">

        <v-btn
          depressed
          @click="close"
        >Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-show="!this.searchBanner"
          :disabled="!canSearch"
          color="primary"
          @click="searchPatientPopulation()"
          depressed
        >Agree and Search Patient Database</v-btn>

      </v-card-actions>

    </v-card>

  </v-dialog>
</template>

<style scoped>
.card > .card__actions {
  flex: none;
}

.card__actions .btn {
  text-transform: capitalize;
}

.building {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  color: white;
}

.content {
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  text-align: center;
  color: #52535f;
}

.sharingLink {
  font-size: 24px;
  font-weight: 400;
  line-height: 1.5;
  margin-top: 20px;
  text-align: center;
  color: #52535f;
  word-wrap: break-word;
}
</style>

<script>
import Avatar from '@/core/components/Avatar'
import DialogMixin from '@/core/mixins/DialogMixin'
import HelperMixin from '@/core/mixins/HelperMixin'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'OneConfirmDialog',
  mixins: [DialogMixin, HelperMixin],
  components: {
    Avatar
  },
  data() {
    return {
      isLoading: false,
      accessRequestingGroup: null,
      showEmptyResults: false,
      searchBanner: false,
      dateFormatted: '',
      patientFirstName: '',
      patientLastName: '',
      patientSearchResultsCleaned: [],
      requestingOrganizations: ['Foo', 'Bar', 'Fizz', 'Buzz'],
      link: 'this',
      className: 'Confirm',
      defaultOptions: {
        okLabel: 'Confirm',
        cancelLabel: 'Cancel',
        showOk: true,
        showCancel: false
      }
    }
  },
  methods: {
    ...mapActions('provider', [
      'search',
      'getProviderIDFromNPI',
      'multipleShareFiles',
      'getProviderAuth'
    ]),
    ...mapActions('admin', ['getPatient', 'fuzzySearchForPatient']),
    selectPatient(patient) {
      const vm = this
      vm.$emit('emitPatient', patient)
      this.close()
    },
    queryMode() {
      this.searchBanner = false
    },
    formatDate(timestamp) {
      let d = new Date(timestamp * 1000)
      let MyDateString =
        ('0' + (d.getMonth() + 1)).slice(-2) +
        '/' +
        ('0' + d.getDate()).slice(-2) +
        '/' +
        d.getFullYear()
      return MyDateString
    },
    close() {
      this.patientFirstName = null
      this.patientLastName = null
      this.dateFormatted = ''
      this.patientSearchResultsCleaned = []
      this.searchBanner = false
      this.cancel()
    },
    searchPatientPopulation() {
      this.isLoading = true
      this.showEmptyResults = false
      this.patientSearchResultsCleaned = []
      console.log('going to search the patient population')
      let nameToSearchWith = this.patientFirstName + ' ' + this.patientLastName
      console.log(nameToSearchWith)
      this.searchBanner = true
      this.fuzzySearchForPatient({
        firstName: this.patientFirstName,
        lastName: this.patientLastName
      })
    }
  },
  watch: {
    patientSearchResults(val) {
      this.patientSearchResultsCleaned = []
      this.isLoading = false
      val.forEach(result => {
        if (
          result.firstName
            .toLowerCase()
            .includes(this.patientFirstName.toLowerCase())
        ) {
          // passed first name
          // birthdateStringforComparison
          console.log(' at the point of comparison: ')
          console.log(result.birthdateString)
          console.log(this.dateFormatted)
          let birthdateComparisonString = result.birthdateString.replace(
            /\//g,
            ''
          )
          if (birthdateComparisonString.includes(this.dateFormatted)) {
            this.patientSearchResultsCleaned.push(result)
          }
        }
      })
      if (!this.patientSearchResultsCleaned.length > 0) {
        this.showEmptyResults = true
      }
    }
  },
  computed: {
    ...mapState('auth', ['currentUserGroups']),
    ...mapState('admin', ['patientSearchResults']),
    searchQuery() {
      return (
        this.patientLastName +
        ', ' +
        this.patientFirstName +
        ' ' +
        this.dateFormatted
      )
    },
    headers() {
      return [
        {
          text: 'Name',
          align: 'left',
          sortable: false,
          value: 'fullName'
        },
        {
          text: 'Gender',
          align: 'left',
          sortable: false,
          value: 'gender'
        },
        {
          text: 'Birthdate',
          align: 'right',
          sortable: false,
          value: 'birthdateString'
        }
      ]
    },
    groupList() {
      console.log('currentUserGroups')
      let ids = []
      let names = []
      console.log(this.currentUserGroups)

      this.currentUserGroups.groups.forEach(group => {
        if (group.provider) {
          // go get the provider information.
          ids.push(group.provider)
          names.push(group.name)
        }
      })
      return names
    },
    canSearch() {
      if (
        this.patientFirstName === '' ||
        this.patientLastName === '' ||
        this.dateFormatted === ''
      ) {
        return false
      }
      return true
    },
    showBuilding() {
      return this.options.unit && this.options.building
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialogs/AdvancedPatientSearchAdmin.vue